module.exports = __webpack_public_path__ + "img/BG121086224.c333553e.png";